// extracted by mini-css-extract-plugin
module.exports = {"fileStyle":"index_fileStyle__2uNhC","nameShow":"index_nameShow__L-zeC","uploadTips":"index_uploadTips__T6nNP","errorStyle":"index_errorStyle__2xpmb"};